export { default } from './SliderSection';
